import './index.css';
import logo from '../../logo.svg'

function Footer() {
    return (
      <div className='footer_block'>                      
        <img src={logo} className="footer_logo" alt="logo" />
        <div className='copyright'>Copyright © 2022. All Right Reserved</div>
      </div>
    )
}

export default Footer;